import res from './res'

res.add('ru', {
    datePeriod: 'Платежи за',
    status: 'статус'
})
